import * as React from 'react';
import { formItemGroupClassName, radioGroupClassName } from './lib/FormItemStyles';
import type { FormItemPropsType } from './types';
import type { FormItemGroupGraphQLType, RadioGroupGraphQLType, SingleLineTextGraphQLType, MultiLineTextGraphQLType, FormItemInputType } from '../../types';

const FormItem: React.FC<FormItemPropsType> = ( props: FormItemPropsType ) => {
    let { formItem } = props;
    const { handleChange, inputValues, checkRequired } = props;

    let value = null;

    if ( formItem.__typename !== 'FormItemGroup' ) {
        formItem = formItem as RadioGroupGraphQLType | SingleLineTextGraphQLType | MultiLineTextGraphQLType;

        const { value: inputValue = null } = inputValues.find( ( input: FormItemInputType ) => (
            input.name === ( formItem as RadioGroupGraphQLType | SingleLineTextGraphQLType | MultiLineTextGraphQLType ).name
        ) );

        value = inputValue;
    }

    switch ( formItem.__typename ) {
    case 'FormItemGroup':
        formItem = formItem as FormItemGroupGraphQLType;

        return (
            <div className={formItemGroupClassName}>
                <h2>{ formItem.title }</h2>
                { formItem.items.map( ( subItem, index ) => (
                    <FormItem
                        key={ index }
                        formItem={ subItem }
                        { ...{ handleChange, inputValues } }
                    />
                ) ) }
            </div>
        );
    case 'RadioGroup':
        formItem = formItem as RadioGroupGraphQLType;

        const { name, options, required } = formItem;

        return (
            <ul className={radioGroupClassName}>
                { options.map( ( { value: radioValue, label, attached }, index ) => {
                    const id = `${ name }-${ index }`;

                    return (
                        <li
                            key={ id }
                        >
                            <div>
                                <input
                                    type='radio'
                                    onChange={ handleChange }
                                    checked={ value === radioValue }
                                    value={ radioValue }
                                    { ...{ id, name, required } }
                                />
                                <label htmlFor={ id }>
                                    { label }
                                </label>
                            </div>
                            { attached &&
                                    <FormItem
                                        key={ index }
                                        formItem={ attached }
                                        checkRequired={ value === radioValue }
                                        { ...{ handleChange, inputValues } }
                                    />
                            }
                        </li>
                    );
                } ) }
            </ul>
        );
    case 'SingleLineText':
    case 'MultiLineText':
        formItem = formItem as SingleLineTextGraphQLType | MultiLineTextGraphQLType;

        return (
            <div className='field'>
                <label htmlFor={ formItem.name }>
                    { formItem.label }
                    { ( checkRequired ? formItem.required : false ) && <span> *</span> }
                </label>
                { formItem.__typename === 'MultiLineText'
                    ? <textarea
                        id={ formItem.name }
                        required={ checkRequired ? formItem.required : false }
                        name={ formItem.name }
                        onChange={ handleChange }
                        { ...{ value } }
                    />
                    : <input
                        id={ formItem.name }
                        required={ checkRequired ? formItem.required : false }
                        type='text'
                        name={ formItem.name }
                        onChange={ handleChange }
                        { ...{ value } }
                    />
                }
            </div>
        );
    default:
        // tslint:disable-next-line
        console.warn( 'unknown FormItem', formItem.__typename );
        break;
    }
};

FormItem.defaultProps = {
    checkRequired: true,
};

export { FormItem };
